import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { closest } from 'next/javascripts/modules/dom';

Component('tr-delay-todo-statistics-table', {
  mixins: [eventListenerMixin],

  connected() {
    this.listenTo(this, 'click', this.handleClick.bind(this));
  },

  disconnected() {
    this.stopListening();
  },

  handleClick(event) {
    const row = closest(event.target, '.member-statistics', event.currentTarget);
    if (row) {
      const url = $(row).data('url');
      event.stopPropagation();
      event.preventDefault();
      if (window.tower.stack) {
        window.tower.stack.load(url, { nocache: true });
      } else if (window.Turbolinks) {
        window.Turbolinks.visit(url);
      }
    }
  },
});
